import axios from 'axios'

export default {
  // 安卓的下载链接 http://wpc.vip.com/apk/link
  getApkLink(params) {
    return axios.get('/apk/link')
  },

  // 唯代购-渠道商-加盟申请登记接口
  // https://wiki.corp.vipshop.com/pages/viewpage.action?pageId=1756369886
  applyChannel(data) {
    const url = process.env.NODE_ENV === 'development' ? '/wdg/channel/apply/v1' : '//wpc-api.vip.com/wdg/channel/apply/v1'
    return axios.post(url, data)
  },

  reportData(data) {
    const url = process.env.NODE_ENV === 'development' ? '/store/data/report' : '//wpc-api.vip.com/store/data/report'
    return axios.post(url, data)
  },
}


// WEBPACK FOOTER //
// ./src/lib/api.js